import React from "react";
import { formatCurrency } from "../../../../../utils/Format";
import { totalCost } from "../../../../../utils/Cost";
import { OrderCostSummaryV2PdfProps } from "../index";
import LineItem from "../LineItem";
import { OrderCategory, OrderStatus } from "../../../../../api/endpoints/Order";

const TotalCost = (props: OrderCostSummaryV2PdfProps) => {
  const { styles, cost, orderStatus, orderCategory, annualTotalCostFootnoteRef = '' } = props;
  const { total_cost } = cost.data;

  if (!total_cost) {
    return null;
  }

  let label = 'Annual total cost';

  if (
    orderStatus === OrderStatus.DRAFT &&
    (orderCategory === OrderCategory.REALTIME || orderCategory === OrderCategory.EU_CUTOUT)
  ) {
    label = 'Total Annual Information Cost';
  }

  return (
    <LineItem
      styles={styles}
      label={[label, annualTotalCostFootnoteRef].join('')}
      value={formatCurrency(totalCost(cost))}
      highlight
    />
  )
}

export default TotalCost;
